// Cable USB enchufado en una placa (prop «Cable USB conectado»): el conector y el cable que sigue sobre la
// mesa. Un clic en el conector, o en el receptáculo si está desenchufado, conecta o desconecta el cable.
import * as THREE from 'three';
import { Builder, M, mat } from '../kit.js';

const TOGGLE = { kind: 'toggle', key: 'usb', label: 'Cable USB: conectar o desconectar' };

const SIZES = {
  // Conector tipo B (Uno, Mega) y mini-B (Nano): bota de plástico, alivio de tensión y grosor del cable.
  B: { boot: [22, 11.5, 16], shell: [8, 8.6], relief: [3.6, 9], r: 2.2 },
  mini: { boot: [15, 6.8, 10.5], shell: [3.2, 7], relief: [2.5, 7], r: 1.7 },
};

/**
 * (x, y, z): centro de la boca del receptáculo, que mira hacia −X; la mesa está en y = 0. Devuelve el grupo
 * con el conector y el cable, y una zona de clic sobre el receptáculo (sirve también desenchufado).
 */
export function usbCable(kind, x, y, z, port) {
  const s = SIZES[kind];
  const [bw, bh, bd] = s.boot;
  const [rr, rl] = s.relief;
  const plastic = mat('#26282c', { roughness: 0.5 });
  const plug = new Builder();
  plug.box(0.8, s.shell[0], s.shell[1], M.metal, x - 0.4, y - s.shell[0] / 2, z); // borde metálico del macho
  plug.rbox(bw, bh, bd, 1.2, plastic, x - 0.8 - bw / 2, y - bh / 2, z);
  plug.cylX(rr, rl, plastic, x - 0.8 - bw - rl / 2, y, z, 18);
  plug.build();
  plug.root.traverse((o) => {
    if (o.isMesh) o.userData.interactive = TOGGLE;
  });
  // El cable sale horizontal y baja suave hasta la mesa (sin cambiar de pendiente en los extremos).
  const cable = new Builder();
  const x0 = x - 0.8 - bw - rl;
  const pts = [];
  const drop = 24;
  for (let k = 0; k <= 8; k++) {
    const t = k / 8;
    const e = t * t * (3 - 2 * t);
    pts.push([x0 - drop * t, s.r + (y - s.r) * (1 - e), z]);
  }
  pts.push([x0 - drop - 150, s.r, z]);
  cable.leg(pts, s.r, plastic);
  cable.build();
  cable.root.traverse((o) => {
    // El cable no tapa clics ni cuenta para encuadrar la cámara.
    o.userData.noPick = true;
    o.userData.noBounds = true;
  });
  const group = new THREE.Group();
  group.add(plug.root, cable.root);
  // Zona de clic invisible sobre el receptáculo
  const hit = new THREE.Mesh(new THREE.BoxGeometry(port[0], port[1], port[2]), new THREE.MeshBasicMaterial({ visible: false }));
  hit.position.set(x + port[0] / 2 - 0.1, y, z);
  hit.userData.interactive = TOGGLE;
  return { group, hit };
}
